// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.salt;
  const v$1 = x.serverBaseUrl;
  const v$2 = x.token;
  const v$3 = x.username;
  return {
    salt: v !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v) : Ppx_deriving_json_runtime.of_json_error("missing field \"salt\""),
    serverBaseUrl: v$1 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"serverBaseUrl\""),
    token: v$2 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$2) : Ppx_deriving_json_runtime.of_json_error("missing field \"token\""),
    username: v$3 !== undefined ? Ppx_deriving_json_runtime.Primitives.string_of_json(v$3) : Ppx_deriving_json_runtime.of_json_error("missing field \"username\"")
  };
}

function to_json(x) {
  return {
    salt: x.salt,
    serverBaseUrl: x.serverBaseUrl,
    token: x.token,
    username: x.username
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
